import clsx from 'clsx'

import styles from './Container.module.scss'

const Container = ({
  children,
  className,
  noPadding,
  style,
}: {
  children: React.ReactNode
  className?: string
  noPadding?: boolean
  style?: React.CSSProperties
}) => (
  <div
    className={clsx(styles.container, className, noPadding && styles.noPadding)}
    style={style}
  >
    {children}
  </div>
)

export default Container
